import type {
  DlnItemLinksEditResult,
  EditDlnItemLinksVariables,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodDlnItemLinksEditPayloadSchema,
  zodDlnItemLinksEditResultSchema,
} from './validations';

/**
 * Adds and removes manual delivery note article links in one request.
 *
 * @param variables - Invoice and the links to add and remove.
 * @returns The counts and the updated invoice detail.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/edit_dln_item_links_invoices__invoice_id__dln_item_links_patch
 */
export async function editDlnItemLinks({
  invoiceId,
  payload,
}: EditDlnItemLinksVariables): Promise<DlnItemLinksEditResult> {
  return vestigasApi
    .patch(ENDPOINT.INVOICE.EDIT_DLN_ITEM_LINKS(invoiceId), {
      json: payload,
      validate: {
        body: zodDlnItemLinksEditPayloadSchema,
        isResponseSensitive: true,
        response: zodDlnItemLinksEditResultSchema,
      },
    })
    .json<DlnItemLinksEditResult>();
}
